export const StaffMenuList = [
  //Dashboard
  {
    title: "Main Menu",
    classsChange: "menu-title",
    extraclass: "first",
  },
  //Dashboard
  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-home" />,
    content: [
      {
        title: "Dashboard 1",
        to: "dashboard",
      },
      {
        title: "Dashboard 2",
        to: "index-2",
      },
      {
        title: "Dashboard 3",
        to: "index-3",
      },
    ],
  },

  //Management
  {
    title: "Tournament Calender",
    to: "event-management",
    iconStyle: <i className="la la-calendar" />,
  },

  // Tournaments
  {
    title: "Tournaments",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-trophy" />,
    content: [
      {
        title: "All Tournaments",
        to: "all-tournament",
      },
      {
        title: "Add Tournaments",
        to: "add-tournament",
      },
      {
        title: "All Teams",
        to: "all-teams",
      },
      {
        title: "Add Team",
        to: "add-team",
      },
      {
        title: "All Players",
        to: "all-tournament-player",
      },
    ],
  },

  //Coaches
  {
    title: "Coaches",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-chalkboard-teacher" />,
    content: [
      {
        title: "All Coaches",
        to: "all-coaches",
      },
      {
        title: "Add Coach",
        to: "add-coach",
      },
      {
        title: "Coach Attendance",
        to: "coach-attendance",
      },
    ],
  },
  //Players
  {
    title: "Players",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-users" />,
    content: [
      {
        title: "All Players",
        to: "all-players",
      },
      {
        title: "Add Players",
        to: "add-player",
      },
      {
        title: "Players Attendance",
        to: "player-attendance",
      },
      {
        title: "Enquiry Players",
        to: "enquiry-player",
      },
      {
        title: "Register Players",
        to: "register-player",
      },
    ],
  },

  //Masters
  {
    title: "Masters",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-crown" />,
    content: [
      {
        title: "All Session",
        to: "all-session",
      },
      {
        title: "All Package",
        to: "all-package",
      },
      {
        title: "Package Type",
        to: "all-package-type",
      },
      {
        title: "Session Type",
        to: "all-session-type",
      },
    ],
  },

  //income-expensive

  {
    title: "CashBook",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-money" />,
    content: [
      {
        title: "All Income & Expensive",
        to: "all-income-expensive",
      },
      {
        title: "Add Income & Expensive",
        to: "add-income-expensive",
      },
      {
        title: "Category",
        to: "all-cashbook-category",
      },
    ],
  },

  //faq

  {
    title: "General",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-question-circle" />,
    content: [
      {
        title: "All Faqs",
        to: "all-faqs",
      },
      {
        title: "Faqs Category",
        to: "all-faqs-category",
      },
    ],
  },

  //security
  {
    title: "Security",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-book" />,
    content: [
      {
        title: "Users",
        to: "all-users",
      },
      {
        title: "Add Users",
        to: "add-users",
      },
      {
        title: "Roles",
        to: "all-roles",
      },
      {
        title: "Add Roles",
        to: "add-roles",
      },
      {
        title: "Permissions",
        to: "all-permissions",
      },
      {
        title: "Add Permissions",
        to: "add-permissions",
      },
    ],
  },

  //Holiday
  {
    title: "Holiday",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-gift" />,
    content: [
      {
        title: "All Holiday",
        to: "all-holiday",
      },
      {
        title: "Add Holiday",
        to: "add-holiday",
      },
      {
        title: "Edit Holiday",
        to: "edit-holiday",
      },
      {
        title: "Holiday Calendar",
        to: "holiday-calendar",
      },
    ],
  },

  //Fees
  {
    title: "Fees",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-dollar" />,
    content: [
      {
        title: "Fees Collection",
        to: "fees-collection",
      },
      {
        title: "Add Fees",
        to: "add-fees",
      },
      {
        title: "Fees Receipt",
        to: "fees-receipt",
      },
    ],
  },
];
